export default function numberFormat(value: number): string {
  if (value == null) {
    return '';
  }
  return value.toLocaleString('ja-JP');
}
